import { AxiosRequestConfig } from "axios";
import ApiBase from "../apiRequestBase";
import { TalkRoomResponse } from "@/apiRequests/models/communityTalk/talkRoomGetResponse";
import { TalkRoomGetRequest } from "../../models/communityTalk/talkRoomGetRequest";
import { TalkRoomPostRequest } from "../../models/communityTalk/talkRoomPostRequest";
import { TalkRoomPostResponse } from "../../models/communityTalk/talkRoomPostResponse";

export default class TalkRoomApiRequest {
	/**
	 * talkroomsのGETリクエスト
	 * @returns
	 */
	public async getTalkRooms(tenantId: string, request: TalkRoomGetRequest): Promise<TalkRoomResponse> {
		// リクエストの設定
		// params,headers等の設定もここで行う

		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/talkrooms`,
			headers: {
				tenantId: tenantId,
			},
			params: request,
			method: "GET",
		};

		return (await ApiBase.request<TalkRoomResponse>(options)) as TalkRoomResponse;
	}

	/**
	 * talkroomsのPOSTリクエスト
	 */
	public async postTalkRooms(tenantId: string, request: TalkRoomPostRequest): Promise<TalkRoomPostResponse> {
		// リクエストの設定
		// params,headers等の設定もここで行う
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/talkrooms`,
			method: "POST",
			headers: {
				tenantId: tenantId,
			},
			data: request,
		};

		return (await ApiBase.requestWithApiToken<TalkRoomPostResponse>(tenantId, options)) as TalkRoomPostResponse;
	}
}
